
   <template>
    <title>0LP | Videography</title>
    <link rel="stylesheet" href="\css\videography.css">
    <body>
      <!-- <ul class="video-t">
        <li v-for="video in videos" :key="video.code" :style="{ backgroundImage: 'url(https://img.youtube.com/vi/' + video.code + '/0.jpg)' }" @click="openVideo(video.code)">
        </li>
      </ul> -->
      <div class="videography-title-container">
        <a href="/" ><img class="logo" src="/images/logo/logo_crp.png" ></a>

        <h3>Videography Gallery</h3>
      </div>
      <div class="img-gallery">
        <img 
          v-for="video in videos" 
          :key="video.video_code" 
          :src="'https://img.youtube.com/vi/' + video.video_code + '/0.jpg'" 
          @click="openVideo(video.video_code)" />
      </div>
      
      <div v-if="showVideoOverlay" class="full-img" @click="closeVideo">
        <!-- <div class="frame"> -->
          <iframe
            :src="'https://www.youtube.com/embed/' + activeVideoCode + '?rel=0&showinfo=0&controls=0&autoplay=1'"
            frameborder="0"
            allowfullscreen
          ></iframe>
        <!-- </div> -->
      </div>
  </body>
  </template>
  
  <script>
  export default {
    name:"VideoGraphy",
    data() {
      return {
        videos:'',
        // images:'',
        showVideoOverlay: false,
        activeVideoCode: null,
      };
    },
    created() {
      this.fetchVideography();
    },
    methods: {
      async fetchVideography() {
        try {
          const response = [
            {
              id: 146,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'w3crEwHQhtA'
            },
            {
              id: 145,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: '8hVyW6HTJBM'
            },
            {
              id: 5,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'qbKIiT5jhy8'
            },
            {
              id: 4,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'AYzVF3M2yks'
            },
            {
              id: 3,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'gQp9QH99JUs'
            },
            {
              id: 1,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'qrm4uAYKHTk'
            },
            {
              id: 6,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: '8et5ttgBjLo'
            },
            {
              id: 7,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: '2IVF_nLXGi0'
            },
            {
              id: 8,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'l0XoIk39Srs'
            },
            {
              id: 9,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'd_LFHouwLAU'
            },
            {
              id: 10,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'bh35gsyjqLM'
            },
            {
              id: 11,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'Pbs2sPcoKQk'
            },
            {
              id: 12,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'v8ablo6o5ms'
            },
            {
              id: 13,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: '77N86Hh1GFo'
            },
            {
              id: 14,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'cvdADf-nZUE'
            },
            {
              id: 15,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'uSJ-HiUrX5Y'
            },
            {
              id: 16,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: 'M_Ve7fsioy4'
            },
            {
              id: 17,
              title: null,
              category: 'videography',
              path: '',
              type: 'video',
              video_code: '8IYVlHO3Wkc'
            },
          ]
          this.videos = response;
          // this.videos = response.data.videographs;
        } catch (error) {
          console.error('Error fetching company details:', error);
        }
      },
      openVideo(code) {
        this.activeVideoCode = code;
        this.showVideoOverlay = true;
      },
      closeVideo() {
        this.showVideoOverlay = false;
        this.activeVideoCode = null;
      },
    },
  };
  </script>
  
  